import { ref, computed } from "@vue/composition-api";
import { debounce } from "@/fp";

export const UseDevice = (() => {
  function checkIsMobile() {
    return innerWidth < 414;
  }

  const _isMobile = ref(checkIsMobile());
  const isMobile = computed(() => _isMobile.value);
  const isDesktop = computed(() => !isMobile.value);

  const debounceCheckIsMobile = debounce(200)(() => {
    _isMobile.value = checkIsMobile();
  });

  window.addEventListener("resize", debounceCheckIsMobile, true);

  return () => {
    return {
      isMobile,
      checkIsMobile,
      isDesktop,
    };
  };
})();
